import { api } from './api';

export type SecurityChallengePurpose =
  | 'withdrawal'
  | 'bank_account_update'
  | 'login_two_factor_enable'
  | 'login_two_factor_disable';

export type SecurityChallengeCurrency = 'BRL' | 'USD' | 'EUR';

export interface WithdrawalChallengeMetadata {
  amount_requested: number;
  currency: SecurityChallengeCurrency;
}

export interface BankAccountChallengeMetadata {
  currency: SecurityChallengeCurrency;
  usd_bank_account_uuid?: string;
}

export type SecurityChallengeMetadata =
  | WithdrawalChallengeMetadata
  | BankAccountChallengeMetadata
  | Record<string, unknown>;

export interface SendChallengeResponse {
  challenge_id: string;
  expires_in: number;
  purpose: string;
}

export interface VerifyChallengeResponse {
  challenge_token: string;
  expires_in: number;
  purpose: string;
}

async function sendChallenge(
  purpose: SecurityChallengePurpose,
  metadata?: SecurityChallengeMetadata,
): Promise<SendChallengeResponse> {
  const isPurposeOnly =
    purpose === 'login_two_factor_enable' ||
    purpose === 'login_two_factor_disable';

  const payload = isPurposeOnly
    ? { purpose }
    : { purpose, metadata: metadata ?? {} };

  const response = await api.post('/v1/authentication/security/challenges', payload);

  const body = response.data?.data ?? response.data;
  return body as SendChallengeResponse;
}

async function verifyChallenge(
  challengeId: string,
  code: string,
): Promise<VerifyChallengeResponse> {
  const response = await api.post(
    `/v1/authentication/security/challenges/${challengeId}/verify`,
    { code },
  );

  const body = response.data?.data ?? response.data;
  return body as VerifyChallengeResponse;
}

export const SecurityChallengeService = {
  sendChallenge,
  verifyChallenge,
};
